import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CFR_37 = () => {
  const faqs = [
    {
      question: "Q: What is “37 CFR” feature used for ?",
      answer:
        "A: The “37 CFR” feature allows users to generate 37 CFR forms. It supports batch preparation for up to 500 application numbers.",
    },
    {
      question: "Q: What inputs are required for generating 37 CFR forms ?",
      answer: `You will need the application number(s), attorney name, and registration number, plus responses to system prompts for signature, POA, and GPOA (if applicable). If POA is selected, the downloaded PDF will contain a merged sequence: POA, GPOA (if provided), and 37 CFR.`,
    },
    {
      question:
        "Q: Can the Power of Attorney (POA) and 37 CFR 3.73 documents be merged for an application number ?",
      answer:
        "A: Yes, JUNE provides the option to generate POA and 3.73 documents together so they can be combined into a single PDF.",
    },
    {
      question: "Q: In which format are the forms downloaded ?",
      answer:
        "A: The forms are downloaded in PDF format. You can edit them using any PDF editor available on your system.",
    },
    {
      question: "Q: Where can I download the generated forms ?",
      answer:
        "A: The output forms are available both in the JUNE interface and via email once processing is complete.",
    },
    {
      question:
        "Q: What happens if I have multiple 37 CFR forms for a single application number ?",
      answer:
        "A: If multiple 37 CFR forms are applicable to a single application number, the system will generate separate PDF forms for each request.",
    },
    {
      question:
        "Q: What chain of title information is included in the 37 CFR form ?",
      answer:
        "A: The chain of title in the 37 CFR form includes only the Assignment of Assignors’ Interest information. Other assignment details are not captured in this version of the form.",
    },
    {
      question:
        "Q: How is applicant information populated in the 37 CFR form ?",
      answer:
        "A: Applicant information in the 37 CFR form is pulled directly from USPTO records. If no applicant data is available, the system will automatically use inventor details as the applicant and update the field accordingly.",
    },
    {
      question: "Q: Can POA and 37 CFR be merged for an application number ?",
      answer:
        "A: Yes. When generating either form, JUNE prompts you to include the other. If selected, both documents are generated together in a single PD.",
    },
  ];

return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": { margin: 0 },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default CFR_37;
